import { jsx as B } from "react/jsx-runtime";
import { s as y } from "../../../Popover.module-B-m2_dp_.js";
import { usePopover as K } from "../hooks/usePopover.js";
import { useCallback as i, cloneElement as x } from "react";
import { hasFocus as I } from "../helpers/hasFocus.js";
const T = ({
  children: c,
  disabledAutoToggle: u,
  minLength: k,
  ...C
}) => {
  const t = K(), s = c == null ? void 0 : c.props, f = k ?? s.minLength ?? 1, w = "focus", S = i(
    (n) => {
      var e;
      const a = n.currentTarget.value;
      u || (a && a.length >= f ? (t == null ? void 0 : t.show) === !1 && (t == null || t.setShowWithReason(!0, n.nativeEvent, w)) : t != null && t.show && (t == null || t.setShowWithReason(!1, n.nativeEvent, w))), (e = s.onChange) == null || e.call(s, n, a);
    },
    [s, u, f, t]
  ), W = i(
    (n) => {
      var e;
      const a = n.currentTarget.value;
      (e = s.onClick) == null || e.call(s, n), !u && !(t != null && t.show) && I(n.currentTarget) && a && a.length >= f && (t == null ? void 0 : t.show) === !1 && (t == null || t.setShowWithReason(!0, n.nativeEvent, w));
    },
    [s, u, f, t]
  ), F = i(
    (n) => {
      var a;
      (a = s.onFocus) == null || a.call(s, n), !u && (!f || n.currentTarget.value.length >= f) && (t == null ? void 0 : t.show) === !1 && (t == null || t.setShowWithReason(!0, n.nativeEvent, "focus"));
    },
    [s, u, f, t]
  ), D = i(
    (n) => {
      var a, e;
      (a = s.onBlur) == null || a.call(s, n), !(n.relatedTarget && "closest" in n.relatedTarget && ((e = n.relatedTarget) != null && e.closest(`.${y.content}`))) && (u || t != null && t.show && (t == null || t.setShowWithReason(!1, n.nativeEvent, "focus")));
    },
    [s, u, t]
  ), g = i(
    (n) => {
      var a, e, l, m, h, E, R;
      (l = (e = (a = t == null ? void 0 : t.getVirtualFocus) == null ? void 0 : a.call(t)) == null ? void 0 : e.onKeyDown) == null || l.call(e, n), n.key === "Tab" && ((E = (h = (m = t == null ? void 0 : t.getVirtualFocus) == null ? void 0 : m.call(t)) == null ? void 0 : h.onBlur) == null || E.call(h, n)), n.key === "ArrowDown" && !(t != null && t.show) && (t == null || t.setShowWithReason(!0, n.nativeEvent, "focus")), n.key === "ArrowUp" && (t != null && t.show) && (t == null ? void 0 : t.activeIndex) === 0 && (t == null || t.setShowWithReason(!1, n.nativeEvent, "focus")), (R = s.onKeyDown) == null || R.call(s, n);
    },
    [s, t]
  );
  return /* @__PURE__ */ B(
    "div",
    {
      ...C,
      className: y.activator,
      ref: t == null ? void 0 : t.api.refs.setReference,
      children: c && t && x(
        c,
        t.interactions.getReferenceProps({
          "aria-autocomplete": "list",
          onBlur: D,
          onChange: S,
          onClick: W,
          onFocus: F,
          onKeyDown: g
        })
      )
    }
  );
};
export {
  T as InputPopoverActivator
};
